import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  notification: cacheLs.get_notification()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
